import { IconButton, Tooltip } from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import React from 'react'
import DOMPurify from 'dompurify'

interface HelpTooltipProps {
  title: string
}

export const HelpTooltip = ({ title }: HelpTooltipProps) => {
  return (
    <Tooltip
      title={<span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }} />}
    >
      <IconButton size="small">
      <InfoOutlinedIcon fontSize={'inherit'}/>
      </IconButton>
    </Tooltip>
  )
}